import { useWealthSavingsSectionContent } from './useWealthSavingsSectionContent';
import { parseWealthSavingsSecurityContent } from '../utils/wealthSavingsContent';

export const useWealthSavingsSecurityContent = () =>
  useWealthSavingsSectionContent(parseWealthSavingsSecurityContent);
